import { useTranslation } from 'react-i18next';
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  Transition
} from '@headlessui/react';
import { Fragment } from 'react';
import { ChevronDownIcon } from '@heroicons/react/solid';
import { classNames } from '../../../helpers/classes';
import useQueryParams from '../../../hooks/useQueryParams';

const OPTIONS = ['name-asc', 'name-desc', 'price-asc', 'price-desc'];

export default function ProductsSort({ ui = '' }: { ui?: string }) {
  const { t } = useTranslation();
  const [query, setQuery] = useQueryParams();

  const { sort = '' } = query;

  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <MenuButton
          className={`group inline-flex justify-center text-sm font-normal opacity-60 ${
            ui ? 'text-white' : 'text-black'
          }`}
        >
          <span>{t('SORT')}</span>
          <ChevronDownIcon
            className={`flex-shrink-0 -mr-1 ml-1 h-5 w-5 ${
              ui ? 'text-white' : 'text-black'
            }`}
            aria-hidden="true"
          />
        </MenuButton>
      </div>

      <Transition
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <MenuItems
          className="origin-top-right absolute -right-32 sm:right-0 mt-2 w-48 rounded-md shadow-2xl bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
          style={{ zIndex: 10 }}
        >
          <div className="py-1">
            {OPTIONS.map((option, i) => (
              <MenuItem key={i}>
                {({ focus }) => (
                  <button
                    onClick={() => setQuery({ sort: option, offset: '0' })}
                    className={classNames(
                      sort === option
                        ? 'font-bold text-black opacity-60'
                        : 'text-black opacity-80',
                      focus ? 'text-black' : '',
                      'block px-4 py-2 text-sm text-left w-full'
                    )}
                  >
                    {t(`SORT_OPTIONS.${option}`)}
                  </button>
                )}
              </MenuItem>
            ))}
          </div>
        </MenuItems>
      </Transition>
    </Menu>
  );
}
